import React from 'react';
import { getAllergenById } from '../data/allergens';
import { AlertTriangle } from 'lucide-react';
interface AllergenBadgeProps {
  allergenId: string;
  size?: 'sm' | 'md';
}
export function AllergenBadge({
  allergenId,
  size = 'md'
}: AllergenBadgeProps) {
  const allergen = getAllergenById(allergenId);
  if (!allergen) return null;
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-2.5 py-1';
  return <span className={`inline-flex items-center gap-1 ${sizeClasses} bg-red-100 text-red-800 rounded-full font-medium border border-red-200`} data-id="element-29">
      <AlertTriangle className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} data-id="element-30" />
      {allergen.nameDE}
    </span>;
}